// removed by extract-text-webpack-plugin
module.exports = {"container":"ResetDeviceModal-container","title":"ResetDeviceModal-title","body":"ResetDeviceModal-body"};